/* eslint-disable no-console */
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { HeliosServerSideRequest } from '@helios/server-side-util'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import {
  ExternalPositionRequest,
  GetPositionsResponse,
  PosIdResponse,
  PositionComparisons,
} from '../../model/single-transaction/security-transfer/position.model'

export const POSITIONS_URL = `helios-positions`
export const POSITIONS_COMPARISON_URL = `${POSITIONS_URL}/comparison`

@Injectable({
  providedIn: 'root',
})
export class HttpPositionsService {
  constructor(private readonly httpClient: HttpClient) {}

  getPositions(
    request: HeliosServerSideRequest<PosIdResponse>,
  ): Observable<PosIdResponse[]> {
    return this.httpClient
      .post<GetPositionsResponse>(POSITIONS_URL, request)
      .pipe(map(response => response.data ?? []))
  }

  getPositionComparisons(
    request: ExternalPositionRequest,
  ): Observable<PositionComparisons> {
    return this.httpClient.post<PositionComparisons>(
      POSITIONS_COMPARISON_URL,
      request,
    )
  }
}
